<template>
  <div
    v-show="isVisible"
    class="popup"
  >
    <div class="popup-data">
      <p>{{ text }}</p>
      <div class="btn-container">
        <button @click="onConfirm('yes')">
          Yes
        </button>
        <button @click="onConfirm('no')">
          No
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Button',
  props: {
    text: {
      type: String,
      default: '',
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      msg: 'Button',
    };
  },
  methods: {
    onConfirm(param) {
      this.$emit('onConfirm', param);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
